module.exports = __webpack_public_path__ + "media/images/fav/meemo_favicon-743d147a40b24e2343b968113385a298.ico";